<template>
    <div class="row"  style=" padding : 0px 0px 50px;position:relative;">
        <div class="container" style="padding-bottom: 50px;">
            <slot class="row_title"  name="row_header">
                월간 팝사인 ㆍ 월간 텍스타일 ㆍ Youtube 
            </slot>

           
                <MainPublicContentsItem v-for="(item, index) in contents_list" :item="item" :index="index" >
                </MainPublicContentsItem>
           
        
        </div>
        <div style="clear:both"></div>
        <div v-if="contents_list.length >=4" @click="more_btn_click()" class="more_btn">더보기 <i class="fas fa-arrow-down"></i></div>
    </div>
</template>

<script>
import MainPublicContentsItem from "@/SPA/Main/Components/MainPublicContentsItem.vue";
import EventBus from "@/EventBus.js"
export default {
    components:{ MainPublicContentsItem },
    props:["contents_list"],
    methods:{
        more_btn_click(){
            EventBus.$emit("more_content");
            EventBus.$emit("get_related_content_more");
        }
    },
}
</script>

<style scoped lang="scss">
.more_btn{
    position: absolute;
    background-color:#007bff;
    border:1px solid #007bff;
    color:#fff;
    font-weight: 14px;
    width: 150px;
    height: 40px;
    text-align: center;
    line-height:40px;
    clear: both;
    cursor: pointer;
    left:50%;
    margin-left:-75px;
    bottom:0px;
    margin-bottom: 50px;
}
.more_btn:hover{
    background-color: #fff;
    color: #007bff;
    border:1px solid #007bff;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/SPA/Main/Components/MainPublicContents.vue